export default __webpack_public_path__ + "24cf74b8a41ef8c1353f0ee2d2cea25c.png";